import { defineMessages } from 'react-intl'

export default defineMessages({
    addComment: {
        id: 'containers.AuditionScopePage.components.Comments.addComment',
        defaultMessage: '+ Add comment',
    },
    commentLabel: {
        id: 'containers.AuditionScopePage.components.Comments.commentLabel',
        defaultMessage: 'New comment',
    },
    saveComment: {
        id: 'containers.AuditionScopePage.components.Comments.saveComment',
        defaultMessage: 'Save comment',
    },
    cancel: {
        id: 'containers.AuditionScopePage.components.Comments.cancel',
        defaultMessage: 'Cancel',
    },
    loading: {
        id: 'containers.AuditionScopePage.components.Comments.loading',
        defaultMessage: 'Loading',
    },
    coordinatorDescription: {
        id: 'containers.AuditionScopePage.components.Comments.coordinatorDescription',
        defaultMessage: 'The comment is an overall comment on the order. It is visible for you and the customer',
    },
    customerDescription: {
        id: 'containers.AuditionScopePage.components.Comments.customerDescription',
        defaultMessage: 'The comment is an overall comment on the order. It is visible for you and the project manager',
    }
})
